// removed by extract-text-webpack-plugin
module.exports = {"tag":"common-LabeledInput-Tags-tag","hugeTag":"common-LabeledInput-Tags-hugeTag"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/LabeledInput/Tags/index.css
// module id = 1761
// module chunks = 0